
import CascateList from "../../../../../../common/components/cascate_list";
import PrimaryButton from "../../../../../../common/components/primary_button";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import { DefaultDatePickerInput } from "../../../../../../common/components/default_date_picker_input";
import DefaultInput from "../../../../../../common/components/default_input";

type Props = {
  DataPesquisa: Date | null;
  DescricaoPesquisa: string | null;
  onClearFilters: () => void;
  handleDataChange: (v: Date | null) => void;
  handleDescricaoChange: (v: string | null) => void;
};

export const Header = ({
  DataPesquisa,DescricaoPesquisa, handleDataChange, handleDescricaoChange, onClearFilters
}: Props) => {

  return (
    <CascateList title="Filtros" defaultOpen>
      <div className="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 items-end">
        <div className="w-full md:col-span-2">
          <DefaultDatePickerInput
          label="Data"
          value={DataPesquisa}
          onChange={dt => handleDataChange(dt)} />
        </div>
          <DefaultInput label="Descrição" name="search_by_ano" value={DescricaoPesquisa ?? ""} onChangeValue={handleDescricaoChange}/>
        <div className="flex justify-end col-span-1 md:col-span-2 lg:col-span-3 xl:col-span-4 mt-2">
          <div className="w-full md:w-[180px]">
            <PrimaryButton
              startIcon={<DynamicIcon nameIcon="ClearRounded" size={25} className="text-black" />}
              buttonColor="yellow"
              onClick={onClearFilters}
            >
              Limpar filtros
            </PrimaryButton>
          </div>
        </div>
        
      </div>
    </CascateList>
  );
};